import App from './app.js';
import My from './my.js';
import Desktop from './desktop.js';

export default{
	
	app:App,
	my:My,
	desktop:Desktop,
	
}